var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$props.title))])])]),_c('div',{staticClass:"level-right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }